import { ClientEmailLink, H1, H2, H3, Paragraph, XStack, YStack } from '@my/ui'

export const PrivacyPolicyScreen = () => {
  return (
    <YStack gap="$4">
      <XStack height="30vh" jc="center" ai="center" bg="$color1">
        <H1>Privacy Policy</H1>
      </XStack>
      <YStack flex={1} py="$8" ai="center" bg="$gray1">
        <YStack w={800} gap="$4" flex={1} $sm={{ w: '100%', px: '$5' }}>
          <H2>Introduction</H2>
          <Paragraph theme="alt1">
            This Privacy Policy outlines how we collect, use, disclose, and protect your
            information. By using our Service, you agree to the collection and use of information in
            accordance with this policy.
          </Paragraph>

          <H3 mt="$8">Collection of Personal Data</H3>
          <Paragraph theme="alt1">
            We may collect personal data to provide and enhance our Services. This may include, but
            is not limited to:
          </Paragraph>
          <YStack gap="$3" theme="alt1">
            <Paragraph>- Personal identification information (e.g., name, email address)</Paragraph>
            <Paragraph>
              - Usage data, including pages visited, service usage time, and diagnostic data.
            </Paragraph>
            <Paragraph>
              - Cookies and similar technologies to personalize your experience.
            </Paragraph>
            <Paragraph>
              - Images uploaded by users for the purpose of creating digital human models.
            </Paragraph>
          </YStack>

          <H3 mt="$8"> Use of Personal Data</H3>
          <Paragraph theme="alt1">
            Your personal data may be used for the following purposes:
          </Paragraph>
          <YStack theme="alt1" gap="$3">
            <Paragraph>- To provide, maintain, and improve our Service.</Paragraph>
            <Paragraph>- To manage user accounts and respond to inquiries.</Paragraph>
            <Paragraph>- For research purposes and to enhance user experience.</Paragraph>
            <Paragraph>
              - Images uploaded by users are used solely for creating the digital human models as
              requested. These images will not be used for any other purpose.
            </Paragraph>
          </YStack>

          <H3 mt="$8">Sharing of Personal Data</H3>
          <Paragraph theme="alt1">We may share your information with:</Paragraph>
          <YStack theme="alt1" gap="$3">
            <Paragraph>- Service Providers for service monitoring and analysis.</Paragraph>
            <Paragraph>
              - Affiliates and business partners for service improvement and promotions.
            </Paragraph>
            <Paragraph>
              - Third parties, with your consent, for business transfers or other purposes.
            </Paragraph>
            <Paragraph>
              - We do not share user-uploaded images with any third parties unless required by law
              or with explicit user consent.
            </Paragraph>
          </YStack>

          <H3 mt="$8">Children’s Privacy</H3>
          <Paragraph theme="alt1">
            Our Service is not intended for individuals under the age of 18. We do not knowingly
            collect personal information from children under 13. If such a case arises, please
            contact us immediately.
          </Paragraph>

          <H3 mt="$8"> International Transfer of Information</H3>
          <Paragraph theme="alt1">
            Depending on your location, information may be transferred and stored in a country other
            than your own. We take measures to safeguard your information during these transfers.
          </Paragraph>

          <H3 mt="$8">User Rights</H3>
          <Paragraph theme="alt1">You have the right to:</Paragraph>
          <YStack theme="alt1" gap="$3">
            <Paragraph>- Withdraw consent to information processing.</Paragraph>
            <Paragraph>
              - Request access to and rectification or erasure of your personal information.
            </Paragraph>
            <Paragraph>- Object to processing and request information portability.</Paragraph>
          </YStack>

          <H3 mt="$8">Retention of Information</H3>
          <Paragraph theme="alt1">
            We retain personal information as long as necessary to fulfill legal obligations and
            service purposes. Uploaded images are retained only as long as necessary to create the
            requested digital human models and are deleted afterward. After the retention period,
            personal information will be deleted.
          </Paragraph>

          <H3 mt="$8">Third-Party Links</H3>
          <Paragraph theme="alt1">
            Our Service may contain links to third-party sites. We are not responsible for the
            privacy practices of these external sites.
          </Paragraph>

          <H3 mt="$8">Changes to This Privacy Policy</H3>
          <Paragraph theme="alt1">
            We reserve the right to update this policy. Changes will be posted on our website, and
            continued use of our service after changes constitutes acceptance.
          </Paragraph>

          <H3 mt="$8">Contact Us</H3>
          <Paragraph theme="alt1">
            For any questions or concerns regarding this Privacy Policy, please contact us at{' '}
            <ClientEmailLink />{' '}
          </Paragraph>
        </YStack>
      </YStack>
    </YStack>
  )
}
